<template>
  <!-- eslint-disable -->
<v-container fluid>
  <v-slide-y-transition mode="out-in">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-toolbar color="teal" class="center" dark style="margin-bottom:15px">
              <v-toolbar-title style="text-align: center; font-weight: 600; width: 100%; position: relative; top: 3px;">Customer Service Number</v-toolbar-title>
            </v-toolbar>

            <v-layout style="padding: 0 15px">
              <v-flex xs1></v-flex>
              <v-flex xs4 offset-xs1 style="margin: 20px 0 0 0; font-size: 16px; position: relative;">Off Hours Phone</v-flex>
              <v-flex xs5><v-text-field xs3 class="phone-number" v-model="phoneNumber" label="Phone Number" prepend-icon="phone" :rules="[rulesPhone, rulesRequired]" ></v-text-field></v-flex>
            </v-layout>

            <v-layout style="padding: 0 25px; flex-wrap: nowrap !important;" class="phone-day-row" row :wrap="false" v-for="day in dayData" :key="day.day">
              <v-flex xs1><v-checkbox xs1 class="vert-center enable-day-cb" v-model="day.enabled"  style="margin: 20px 0 0 0; padding: 0; height: auto;"></v-checkbox></v-flex>
              <v-flex xs3 class="day-label" style="text-transform: capitalize; margin: 20px 0 0 0; font-size: 16px">{{day.day}}</v-flex>
              <div xs4 style="position: relative; padding-right: 30px;">
                <v-menu id="time-picker-menu-to" class="time-picker-menu-to" :close-on-content-click="false" :nudge-right="33" :nudge-bottom="46">
                  <template v-slot:activator="{ on }">
                    <v-text-field class="time-picker-text-to" v-on="on" v-model="day.from" :disabled="!day.enabled" label="From" prepend-icon="access_time" :rules="[rulesRequired]" readonly></v-text-field>
                  </template>
                  <v-time-picker :width="290" id="time-picker-clock-to" style="" v-if="day.from && day.enabled" v-model="day.from" format="24hr"></v-time-picker>
                </v-menu>
              </div>
              <div xs4 style="position: relative; padding-right: 15px;">
                <v-menu id="time-picker-menu-from" :close-on-content-click="false" :nudge-right="33" :nudge-bottom="46">
                  <template v-slot:activator="{ on }">
                    <v-text-field class="time-picker-text-from" v-on="on" v-model="day.to" :disabled="!day.enabled" label="To" prepend-icon="access_time" :rules="[rulesRequired]" readonly></v-text-field>
                  </template>
                  <v-time-picker id="time-picker-clock-from" style="" v-if="day.to && day.enabled" v-model="day.to" :width="290" format="24hr"></v-time-picker>
                </v-menu>
              </div> 
            </v-layout>
            <v-btn @click="save" style="margin: 0 15px 15px 15px;" class="save-btn" :disabled="!valid">save</v-btn>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-slide-y-transition>
</v-container>
<!-- eslint-enable -->
</template>

<script>
import phoneConfigModule, {
  PHONE_CONFIG_NAMESPACE
} from "./store/phoneConfigStore";
import { mapGetters } from "vuex";
import RulesMixin from "@/mixins/RulesMixin.js";

export default {
  name: "CustomerService",
  components: {},
  mixins: [RulesMixin],
  data() {
    return {
      test: null,
      valid: false,
      dayData: [],
      phoneNumber: ""
    };
  },
  computed: {
    ...mapGetters(PHONE_CONFIG_NAMESPACE, [])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(PHONE_CONFIG_NAMESPACE, phoneConfigModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.PHONES_ADMIN]).then(
      res => {
        if (res) {
          this.load();
        } else this.$goHome();
      }
    );
  },
  methods: {
    load() {
      return this.$store
        .dispatch(`${PHONE_CONFIG_NAMESPACE}/LOAD`)
        .then(response => {
          this.phoneNumber = response.phoneNumber;
          this.dayData = response.dayData;
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        return this.$store.dispatch(`${PHONE_CONFIG_NAMESPACE}/SAVE`, [
          {
            type: "OFF_HOURS_PHONE_NUMBER",
            value: this.phoneNumber
          },
          {
            type: "CALL_CENTER_HOURS",
            value: JSON.stringify(this.dayData)
          }
        ]);
      }
    }
  }
};
</script>
